export const returnRolesOptions = (
  userEmail: string,
  userRole: string,
  loggedInUserEmail: string,
  currentUserRole: string,
) => {
  if (userRole === 'EXP_SUPER_ADMIN') return ['EXP_SUPER_ADMIN'];
  if (currentUserRole === 'EXP_ADMIN')
    return ['EXP_PROJECT_CREATOR', 'EXP_ADMIN'];

  if (userEmail === loggedInUserEmail)
    return ['EXP_PROJECT_CREATOR', 'EXP_ADMIN'];
  return ['EXP_PROJECT_CREATOR', 'EXP_ADMIN', 'EXP_SUPER_ADMIN'];
};
